import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";

const StatusReason = ({ show, onClose }) => {
   
    return (
        <Modal show={show} size="md"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Resolve Status</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Reason <span className="required">*</span></label>
                            <textarea rows={2} className="form-control h-auto" name="comment" placeholder="Reason" />
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Submit<i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal >
    );
};

export default StatusReason;
